import { ExpandingTooltip } from "./ExpandingTooltip";

import {
  TemplateEnabled,
  TemplateType,
  DocumentType,
} from "./classification/ModelTypeEnabledDocTypeTooltips";

import {
  TTClassificationPanel,
  TTDocumentEndPatterns,
  TTDocumentStartPatterns,
  TTTemplateName,
  TTViewOcrEnd,
  TTViewOcrStart,
} from "./TTClassification";

import {
  TTAnchorButton,
  TTColumnEndLabel,
  TTColumnName,
  TTColumnsHeader,
  TTColumnStartLabel,
  TTColumnSuggestions,
  TTHardcodeButton,
  TTHighlightColumns,
  TTViewExtractedTable,
} from "./TTColumns";

import {
  TTAllowEmpty,
  TTClearButton,
  TTConfidenceLabel,
  TTConfidenceThreshold,
  TTDlfMatcherTypeDropdown,
  TTDlfPanel,
  TTDlfPanelDropdown,
  TTEditButton,
  TTFieldStatusLabel,
  TTGenerateReuse as TTDlfGenerateReuse,
  TTGenerateReuseAll as TTDlfGenerateReuseAll,
  TTKeyValueMatcherKeyLabel,
  TTKeyValueMatcherValueLabel,
  TTKeyValueMatcherValueSuggestions,
  TTReusableButton,
} from "./TTDocumentFieldConfiguration";

import {
  TTBatchId,
  TTBatchInstanceDropdown,
  TTCollapseAllBatches,
  TTDeleteBatches,
  TTDocumentSelectorPanel,
  TTReprocessBatches,
  TTSaveTemplates,
  TTSearchBatch,
  TTSelectAllBatches,
  TTSelectBatch,
} from "./TTDocumentSelector";

import { TTNotesPanel, TTNotesPanelButton } from "./TTNotes";

import {
  TTTablePanel,
  TTTablePanelDropdown,
  TTGenerateReuse as TTTableGenerateReuse,
  TTViewOcr as TTTableViewOcr,
  TTUseOffset,
  TTTableClassificationRulesLabel,
  TTTableHardStopRule,
  TTTableSoftStopRule,
  TTTableStartRule,
  TTTableStartRuleReusable,
  TTIgnoreRuleCount,
  TTIgnoreRuleButton,
  TTIgnoreRuleLabel,
} from "./TTTables";

import {
  TTReplaceRuleLabel,
  TTReplaceWithLabel,
  TTAddRule as TTTransformAddRule,
  TTDeleteRule as TTTransformDeleteRule,
  TTTestRule as TTTransformationTestRule,
} from "./TTTransformation";

import {
  TTDlfRequireAllLabel,
  TTAddRule as TTValidationAddRule,
  TTDeleteRule as TTValidationDeleteRule,
  TTTestRule as TTValidationTestRule,
  TTTableRequireAllLabel as TTValidationTableRequireAllLabel,
} from "./TTValidation";

export {
  // Item 1
  TTClassificationPanel,
  // Item 2
  TTTemplateName,
  // Item 3
  TemplateType as TTTemplateType,
  // Item 4
  TemplateEnabled as TTTemplateEnabled,
  // Item 5
  DocumentType as TTDocumentType,
  // Item 6
  TTDlfPanel,
  // Item 7 ?
  TTFieldStatusLabel,
  // Item 8
  TTDlfMatcherTypeDropdown,
  // Item 9 never existed
  // Item 10
  TTEditButton,
  // Item 11
  TTDlfGenerateReuse,
  // Item 12
  TTClearButton,
  // Item 13
  TTDocumentSelectorPanel,
  // Item 14
  ActionBarBatchClass as TTActionBarBatchClass,
  // Item 15
  TTBatchInstanceDropdown,
  // Item 16
  TTDeleteBatches,
  // Item 17
  TTSaveTemplates,
  // Item 18
  TTReprocessBatches,

  // Item 19 - handled by DocumentViewHeaderButtons
  // Item 20 - handled by DocumentViewHeaderButtons

  // Item 21
  TTDocumentStartPatterns,
  // Item 22
  TTDocumentEndPatterns,
  // Item 23 - handled by DlfEditorHeader
  // Item 24
  TTDlfGenerateReuseAll,
  // Item 25
  TTViewOcrStart,
  // Item 26
  TTViewOcrEnd,
  // Item 27
  TTSearchBatch,
  // Item 28
  TTSelectAllBatches,
  // Item 29
  TTSelectBatch,
  // Item 30
  TTCollapseAllBatches,
  // Item 31
  TTBatchId,
  // Items 32 to 39 deleted
  // Item 39A
  TTDlfPanelDropdown,
  // Item 40
  TTAllowEmpty,
  // Item 41
  TTReusableButton,
  // Item 42
  TTConfidenceThreshold,
  // Item 43
  TTConfidenceLabel,
  // Item 44
  TTKeyValueMatcherKeyLabel,
  // Item 45
  TTKeyValueMatcherValueLabel,
  // Item 46
  TTKeyValueMatcherValueSuggestions,
  // Items 47 to 49 never exited
  // Item 50
  TTTablePanel,
  // Item 51
  TTTablePanelDropdown,
  // Item 52
  TTTableGenerateReuse,
  // Item 53
  TTTableViewOcr,
  // Item 54
  TTUseOffset,
  // Item 55
  TTTableClassificationRulesLabel,
  // Item 56
  TTTableStartRule,
  // Item 57
  TTTableSoftStopRule,
  // Item 58
  TTTableHardStopRule,
  // Item 59
  TTTableStartRuleReusable,
  // Item 60
  TTIgnoreRuleCount,
  // Item 61
  TTIgnoreRuleLabel,
  // Item 62
  TTIgnoreRuleButton,
  // Item 63
  TTColumnsHeader,
  // Item 64
  TTHighlightColumns,
  // Item 65
  TTViewExtractedTable,
  // Item 66
  TTAnchorButton,
  // Item 67
  TTHardcodeButton,
  // Item 68
  TTColumnSuggestions,
  // Item 69
  TTColumnStartLabel,
  // Item 70
  TTColumnEndLabel,
  // Item 71
  TTColumnName,
  // Items 72 to 79 never existed
  // Item 80
  TTNotesPanel,
  // Item 81
  TTNotesPanelButton,
  // Items 82 to 93 never existed
  // Item 94
  TTDlfRequireAllLabel,
  // Item 95
  TTValidationAddRule,
  // Item 96
  TTValidationDeleteRule,
  // Item 97
  TTValidationTestRule,

  // Item A
  TTReplaceRuleLabel,
  // Item B
  TTReplaceWithLabel,
  // Item C
  TTTransformAddRule,
  // Item D
  TTTransformDeleteRule,
  // Item E
  TTTransformationTestRule,

  // Item A2
  TTValidationTableRequireAllLabel,
  TTOcrConfidenceThreshold,
  TTTemplateOcrConfidenceThreshold,
};

// Item 14
const ActionBarBatchClass: ExpandingTooltip = (short) => {
  if (short) return <p>Select the batch class you want to work on.</p>;
  return (
    <>
      <p>
        Selecting the batch class limits the batches and documents displayed and
        determines the batch class that any new templates are connected to.
      </p>
    </>
  );
};

const TTOcrConfidenceThreshold: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>
        Configure the threshold for when an OCR Confidence warning will be
        raised for this Document field.
      </p>
    );
  return (
    <>
      <p>
        Configure the threshold for when an OCR Confidence warning will be
        raised for this Document field. The Accelerator will use this OCR
        Confidence threshold value unless an override value is set when
        configuring a Template.
      </p>
    </>
  );
};

const TTTemplateOcrConfidenceThreshold: ExpandingTooltip = (short) => {
  if (short)
    return (
      <p>
        Configure the threshold for when an OCR Confidence warning will be
        raised for this Template field.
      </p>
    );
  return (
    <>
      <p>
        Configure the threshold for when an OCR Confidence warning will be
        raised for this Template field. The Accelerator will use the OCR
        Confidence threshold from the Batch Class if no threshold is set for the
        Template.
      </p>
    </>
  );
};
